export default "__VITE_PUBLIC_ASSET__bcc7a29d__"